/* NOSEKNOWS apply form — Epic 2 / improvement 0415 phase E
   - fetch POST to /apps/nk/apply
   - honeypot + timestamp bot protection
   - success/error state management
   - 日本語メッセージ + 抽選日時表示
*/

(function(){
  "use strict";

  var ENDPOINT = "/apps/nk/apply";
  // ボットが即時送信するのを防ぐ最小待機時間（秒）
  var MIN_ELAPSED_SEC = 3;

  function init(){
    var forms = document.querySelectorAll(".nk-apply-form");
    for (var i = 0; i < forms.length; i++){
      setupForm(forms[i]);
    }
  }

  function setupForm(form){
    var tsField = form.querySelector("[data-nk-ts]");
    var hpField = form.querySelector("[data-nk-hp]");
    var emailField = form.querySelector("[data-nk-email]");
    var dropField = form.querySelector("[data-nk-drop]");
    var btn = form.querySelector("[data-nk-apply-btn]");
    var msgEl = form.querySelector("[data-nk-apply-msg]");
    var drawAt = form.getAttribute("data-nk-draw-at") || "";
    var drawAtJp = form.getAttribute("data-nk-draw-at-label") || "";

    if (!tsField || !emailField || !dropField || !btn || !msgEl) return;

    tsField.value = Math.floor(Date.now() / 1000);

    var drawAtMs = Date.parse(drawAt);
    if (!Number.isNaN(drawAtMs) && drawAtMs <= Date.now()){
      disableBtn(btn);
      btn.textContent = "CLOSED / 受付終了";
      if (emailField.type !== "hidden") emailField.disabled = true;
      return;
    }

    form.addEventListener("submit", function(e){
      e.preventDefault();

      // ハニーポット: クライアント側でも二重防御
      if (hpField && hpField.value !== ""){
        applyOkMessage(msgEl, drawAtJp);
        disableBtn(btn);
        btn.textContent = "APPLIED / 応募済み";
        return;
      }

      var elapsed = Math.floor(Date.now() / 1000) - parseInt(tsField.value, 10);
      if (elapsed < MIN_ELAPSED_SEC){
        showError(msgEl, "少しお待ちください");
        return;
      }

      var email = (emailField.value || "").trim();
      if (!email || !isValidEmail(email)){
        showError(msgEl, "メールアドレスの形式が正しくありません");
        return;
      }

      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = "...";
      clearMsg(msgEl);
      var turnstileField = form.querySelector(
        'input[name="cf-turnstile-response"]'
      );

      var payload = {
        email: email,
        drop_id: dropField.value,
        hp_field: hpField ? hpField.value : "",
        _t: parseInt(tsField.value, 10),
        turnstile_token: turnstileField ? turnstileField.value : ""
      };

      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
      .then(function(res){ return res.json(); })
      .then(function(data){
        if (data.ok){
          applyOkMessage(msgEl, drawAtJp);
          disableBtn(btn);
          btn.textContent = "APPLIED / 応募済み";
        } else {
          handleError(data.error, btn, msgEl, drawAtJp);
        }
      })
      .catch(function(){
        showError(msgEl, "通信エラーが発生しました。時間をおいて再度お試しください。");
        btn.disabled = false;
        btn.textContent = "APPLY / 応募";
        if (window.turnstile) window.turnstile.reset();
      });
    });
  }

  function handleError(code, btn, msgEl, drawAtJp){
    // ALREADY_APPLIEDは実質「応募済み」なのでOK表示と同じ扱い
    if (code === "ALREADY_APPLIED"){
      applyOkMessage(msgEl, drawAtJp, true);
      disableBtn(btn);
      btn.textContent = "APPLIED / 応募済み";
      return;
    }

    var messages = {
      "INVALID_EMAIL": "メールアドレスの形式が正しくありません",
      "RATE_LIMITED": "送信回数が多すぎます。時間をおいて再度お試しください。",
      "BANNED": "お客様のアカウントでは応募できません。",
      "INVALID_DROP": "この商品は現在応募を受け付けていません。",
      "APPLY_CLOSED": "応募期間は終了しました。次回のDropをお待ちください。",
      "CHALLENGE_REQUIRED": "認証に失敗しました。少し待ってからもう一度お試しください。"
    };
    var msg = messages[code] || "応募に失敗しました。時間をおいて再度お試しください。";
    var isFinal =
      code === "BANNED" || code === "INVALID_DROP" || code === "APPLY_CLOSED";

    showError(msgEl, msg);

    if (!isFinal){
      btn.disabled = false;
      btn.textContent = "APPLY / 応募";
      if (code === "CHALLENGE_REQUIRED" && window.turnstile){
        window.turnstile.reset();
      }
    } else {
      btn.textContent = code === "APPLY_CLOSED"
        ? "CLOSED / 受付終了"
        : "UNAVAILABLE / 応募不可";
      disableBtn(btn);
    }
  }

  /**
   * 応募受付成功時のメッセージを表示。
   * @param {HTMLElement} el
   * @param {string} drawAtJp - '2026年4月1日 20:00' 形式、空文字で省略
   * @param {boolean} alreadyApplied - すでに応募済の場合
   */
  function applyOkMessage(el, drawAtJp, alreadyApplied){
    el.innerHTML = "";
    el.style.display = "block";
    el.style.color = "var(--c1)";

    var head = document.createElement("div");
    head.textContent = alreadyApplied ? "すでに応募済みです" : "応募を受け付けました";
    head.style.fontWeight = "600";
    el.appendChild(head);

    if (drawAtJp){
      var drawRow = document.createElement("div");
      drawRow.style.marginTop = "6px";
      drawRow.textContent = "抽選日時: " + drawAtJp;
      el.appendChild(drawRow);
    }

    var tail = document.createElement("div");
    tail.style.marginTop = "6px";
    tail.style.color = "var(--muted)";
    tail.textContent = "結果はメールまたはLINEでお知らせします。";
    el.appendChild(tail);

    var statusLink = document.createElement("a");
    statusLink.href = "/pages/status-check";
    statusLink.className = "nk-link nk-bi-label";
    statusLink.style.marginTop = "8px";
    statusLink.textContent = "STATUS / 状態確認";
    el.appendChild(statusLink);
  }

  function showError(el, text){
    el.innerHTML = "";
    el.textContent = text;
    el.style.color = "var(--c2)";
    el.style.display = "block";
  }

  function clearMsg(el){
    el.innerHTML = "";
    el.style.display = "none";
  }

  function isValidEmail(email){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function disableBtn(btn){
    btn.disabled = true;
    btn.style.opacity = "0.4";
    btn.style.cursor = "default";
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
